module.exports = __webpack_public_path__ + "img/BIRD SHADES BW.98d6f80.svg";